import { useState } from "react";
import { useLenis } from "lenis/react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { SITE } from "@/data/site";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Treatments", href: "#services" },
  { label: "Reviews", href: "#reviews" },
  { label: "Journal", href: "#journal" },
  { label: "FAQ", href: "#faq" },
  { label: "Visit", href: "#visit" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const lenis = useLenis();

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    lenis?.scrollTo(href, { offset: -72, duration: 1.4 });
  };

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 border-b border-sand/60 bg-bone/70 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 lg:px-12">
        <a
          href="#top"
          onClick={(e) => go(e, "#top")}
          data-testid="header-logo"
          className="font-serif text-xl tracking-tight text-forest"
        >
          {SITE.name} <span className="text-clay">{SITE.credential}</span>
        </a>

        <nav className="hidden items-center gap-8 lg:flex" data-testid="header-nav">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-xs uppercase tracking-[0.2em] text-forest/70 transition-colors duration-300 hover:text-forest"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#visit"
            onClick={(e) => go(e, "#visit")}
            data-testid="header-book-button"
            className="group hidden items-center gap-2 rounded-full bg-pine px-6 py-2.5 text-xs uppercase tracking-[0.2em] text-bone transition-transform duration-300 hover:-translate-y-0.5 sm:inline-flex"
          >
            Book Online
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <button
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
            className="text-forest lg:hidden"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-sand/60 bg-bone/95 px-6 py-6 backdrop-blur-xl lg:hidden" data-testid="mobile-menu">
          <div className="flex flex-col gap-5">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => go(e, l.href)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className="font-serif text-2xl text-forest"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#visit"
              onClick={(e) => go(e, "#visit")}
              data-testid="mobile-book-button"
              className="mt-2 inline-flex w-fit items-center gap-2 rounded-full bg-pine px-6 py-3 text-xs uppercase tracking-[0.2em] text-bone"
            >
              Book Online <ArrowUpRight className="h-3.5 w-3.5" />
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
